import {Component, OnInit, Renderer2} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import {TypAuswahlFeldListe} from '../../../interfaces/interfaces.regisafe';

@Component({
	selector: 'app-liste-art',
	templateUrl: './liste-art.component.html',
	styleUrls: ['./liste-art.component.scss'],
})
export class ListeArtComponent implements OnInit {
	props;
	searchText: string;
	markedArts: Array<any> = [];
	multipleChoice: false;

	constructor(private modalCtrl: ModalController,
				private navParams: NavParams,
				private renderer: Renderer2) {
	}

	ngOnInit() {
		// Übergebene Daten aus navParams
		this.props = this.navParams;
		// Mehrfachauswahl?
		this.multipleChoice = this.props.data.multiple;
		// Listentyp
		const listType: TypAuswahlFeldListe = this.props.data.type;
		// einfache Liste umschreiben zu Array von Objecten.
		// es muss dann keine separates HTML Template zur Verfügung gestellt werden
		if (listType === 'simplelist') {
			this.props.data.list.forEach((item, index) => {
				this.props.data.list[index] = {name: item};
			});
		} else {
			// do nothing
		}

		// bereits übergebene Werte aus dem Eingabefeld (value-String aus übergebenen Daten)
		// in Array umwandeln und entsprechend als Vorauswahl markieren
		if (this.props.data.value.length !== 0) {
			const valueArr = this.props.data.value.split(';');
			valueArr.forEach((item) => {
				const artitem = this.props.data.list.find(o => o.name === item);
				console.log('-- artitem: ', artitem);
				if (artitem) {
					artitem.marked = true;
					this.markedArts.push(artitem);
				}
			});
		}
	}

	/**
	 * Modales Fenster schließen ohne Daten zu übergeben (false)
	 */
	async closeModal() {
		const data = false;
		await this.modalCtrl.dismiss(data);
	}

	/**
	 * Modales Fenster schließen und Daten (markierte Felder) übergeben
	 */
	async getData() {
		const data = this.markedArts;
		await this.modalCtrl.dismiss(data);
	}

	/**
	 * toggleArt()
	 *
	 * Listenelemente markieren, demarkieren
	 * und an Array/Liste markedArts übergeben
	 *
	 * @param event
	 * @param artitem
	 */
	toggleArt(event, artitem) {

		if (!this.multipleChoice) {
			this.markedArts = [];
			this.props.data.list.forEach((item) => {
				item.marked = false;
			});
		}

		const className = 'marked';
		const hasClass = event.target.classList.contains(className);

		if (hasClass) {
			artitem.marked = false;
			this.renderer.removeClass(event.target, className);
			const filtered = this.markedArts.filter((o: any) => {
				return o.name !== artitem.name;
			});
			this.markedArts = filtered;
		} else {
			artitem.marked = true;
			this.renderer.addClass(event.target, className);
			this.markedArts.push(artitem);
		}

	}

	/**
	 * removeArtItem()
	 *
	 * Auswahl entfernen
	 *
	 * @param item
	 * @param index
	 */
	removeArtItem(item, index) {
		this.markedArts.splice(index, 1);
		this.props.data.list.find((obj) => {
			const o = obj.name === item.name;
			if (o) {
				obj.marked = false;
			}
		});
	}

	/**
	 * Eingabe Filter zurücksetzen
	 */
	clearInput() {
		this.searchText = '';
	}
}
